import React, { useState, useEffect, useContext } from 'react';
import { Table, Button, Modal, Label, Select, TextInput, Alert } from "flowbite-react";
import ReusableDataTable from '../../../hooks/ReusableDataTable';
import CustomSelectwithText from '../../../hooks/CustomSelectwithText';
import axios from "axios";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import CSingleBoxingQuantity from './CSingleBoxingQuantity';
import { FaPen, FaPlus } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import useInputValidation from '../../../hooks/useInputValidation';
import { AuthContext } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { TbCircleLetterRFilled } from "react-icons/tb";
import { FaRectangleList } from "react-icons/fa6";
import RequestActivityModal from '../../../hooks/RequestActivityModal';
import CustomSelect from '../../../hooks/CustomSelect';

function SingleBoxing({ orderid }) {
    const { user } = useContext(AuthContext);
    const navigate = useNavigate();
    const url = localStorage.getItem("url");
    useEffect(() => {
        if (!user) {
            navigate("/");
        } else {

        }
    }, [user, navigate]);

    const [data, setData] = useState([]);
    const [selectedMarker, setselectedMarker] = useState({});
    const [selectedColor, setselectedcolor] = useState();
    const [completeStatusKey, setcompleteStatusKey] = useState(0) //for re render
    const [Colour, setColour] = useState({});
    const [AddBoxing, setAddBoxing] = useState(false);

    const [Input, setInput] = useState({});
    const today = new Date().toISOString().split('T')[0];
    const [SizeVarientOptions, setSizeVarientOptions] = useState({});
    const [EditModal, setEditModal] = useState(false);
    const [DeleteModal, setDeleteModal] = useState(false);
    const [boxNoOptions, setBoxNoOptions] = useState([]);
    const [selectedBoxNo, setSelectedBoxNo] = useState("");
    const [loading, setLoading] = useState(false);
    const [available_quantityFlag, setavailable_quantityFlag] = useState(0);
    const [requestModal, setrequestModal] = useState(false);
    const [requestActivityModal, setrequestActivityModal] = useState(false);
    const [requestActivityData, setrequestActivityData] = useState({});

    const role = sessionStorage.getItem('role');

    const fetchrequestActivity = async (bog_log_Id) => {
        try {
            const response = await axios.get(`/requests/request/${bog_log_Id}`, {
                params: { section_name: 'SingleBoxing' },
            });
            const requestActivityData = response.data.data;
            setrequestActivityData(requestActivityData);
        } catch (error) {
            console.error("Error fetching requestActivityData:", error);
        }
    };

    useEffect(() => {
        if (orderid) {
            fetchBoxNos();
        }
    }, [orderid]);



    const fetchBoxNos = async () => {
        try {
            const response = await axios.get(`single_boxing/box_no/${orderid}`);
            // console.log(response);

            // Extract box_no array from response.data
            setBoxNoOptions(response.data.box_no || []);
        } catch (error) {
            console.error("Error fetching box numbers:", error);
        }
    };

    const createBoxNo = async () => {
        setLoading(true);
        try {
            const response = await axios.post(`/single_boxing/box_no/${orderid}`);
            const newBoxNo = response.data;
            const alreadyExists = boxNoOptions.includes(newBoxNo);
            if (!alreadyExists) {
                setBoxNoOptions([...boxNoOptions, newBoxNo]);
            }
    
            setSelectedBoxNo(newBoxNo);
    
           
        } catch (error) {
            console.error("Error creating box number:", error);
        } finally {
            setLoading(false);
        }
    }
    const fetchmarker = async () => {
        try {
            const response = await axios.get(`/single_boxing/sizevarient_options/${orderid}`);
            const markerData = response.data.size_options;
            setSizeVarientOptions(markerData);
        } catch (error) {
            console.error("Error fetching Marker data:", error);
        }
    };


    useEffect(() => {
        fetchBoxing();
        fetchmarker();
        fetchColour();
    }, []);

    const handleRequest = async (e) => {
        e.preventDefault();

        setrequestModal(false)
        const requestData = {
            ...Input,
            order_id: orderid,
            staff_id: user.staff_id,
            section_name: 'SingleBoxing',
            sub_order_id : Input.sub_order_id,
            section_id: Input.id,
            reason: Input.reason
        };
        try {
            axios
                .post('/single_boxing/request', requestData)
                .then((response) => {
                    if (response.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Requested",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        fetchBoxing();
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }
    };



    //  Fetch all logs
    const fetchBoxing = async () => {
        try {
            const response = await axios.get(`single_boxing/single_boxing/${orderid}`);
            const result = response.data;
            const logs = result.logs;
            setData(logs);
        } catch (error) {
            console.error("Error fetching logs:", error);
        }
    };

    const fetchColour = async () => {
        try {
            const response = await axios.get(`/single_boxing/color_options/${orderid}`);
            const ColourData = response.data.color_options;

            const formattedColours = ColourData.map(colour => ({
                ...colour,
                imgSrc: colour.imgSrc ? `${url}${colour.imgSrc}` : null
            }));

            setColour(formattedColours);

        } catch (error) {
            console.error("Error fetching Colour data:", error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (Object.keys(selectedMarker).length !== 0) {
            const totalPiece = Object.values(selectedMarker)
                .map(Number)
                .reduce((acc, value) => acc + value, 0);

            const requestData = {
                ...Input,
                // orderdate:today,
                order_id: orderid,
                sub_order_id: selectedColor,
                date: today,
                box_no: selectedBoxNo,
                size_variant_quantity: selectedMarker,
                total_piece: totalPiece,
                staff_id: user.staff_id,
            };
            try {
                axios
                    .post('single_boxing/single_boxing', requestData)
                    .then((response) => {
                        if (response.data.success === 1) {
                            Swal.fire({
                                icon: "success",
                                text: "Boxing Completed ",
                                type: "success",
                                timer: 2000,
                                showConfirmButton: false,
                            });
                            fetchBoxing();
                            setAddBoxing(false);
                            setavailable_quantityFlag(0);
                            setcompleteStatusKey((prevKey) => prevKey + 1);

                        }
                        else if (response.data.success === 2) {
                            Swal.fire({
                                icon: "error",
                                text: "Quantity  exceeds the allowed limit....",
                                type: "error",
                                timer: 2000,
                                showConfirmButton: false,
                            });

                        }
                        else if (response.data.success === 3) {
                            Swal.fire({
                                icon: "error",
                                text: "The production section has not been completed",
                                type: "error",
                                timer: 2000,
                                showConfirmButton: false,
                            });
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                text: "Server Problem. Please Try Again...",
                                type: "error",
                                timer: 2000,
                                showConfirmButton: false,
                            });
                        }
                        setselectedMarker({});
                        setselectedcolor();
                        return;
                    });
            } catch (error) {
                throw error;
            }
        } else {
          
            Swal.fire({
                icon: "error",
                text: "please fill the values...",
                type: "error",
                timer: 2000,
                showConfirmButton: false,
            });
        }
    };


    const handleUpdate = async (event) => {
        event.preventDefault(); // Prevent default form submission

        const totalPiece = Object.values(selectedMarker)
            .map(Number)
            .reduce((acc, value) => acc + value, 0);

        const requestData = {
            ...Input,
            order_id: orderid,
            sub_order_id: selectedColor,
            box_no: selectedBoxNo,
            date: Input.date,
            markerwithquantity: selectedMarker,
            total_piece: totalPiece,
            staff_id: user.staff_id,
        };

        try {
            await axios.put(`single_boxing/single_boxing/${Input.id}`, requestData)
                .then((response) => {
                    if (response.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Updated successfully!",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        fetchBoxing();
                        setEditModal(false);
                        setcompleteStatusKey((prevKey) => prevKey + 1);
                        setInput({});
                    } else if (response.data.success === 2) {
                        Swal.fire({
                            icon: "error",
                            text: "Quantity exceeds the allowed limit....",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else if (response.data.success === 3) {
                        Swal.fire({
                            icon: "error",
                            text: "The cutting DC section has not been completed.",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                });
        } catch (error) {
            console.error("Error updating boxing:", error);
        }
    };


    const handleDelete = async () => {
        try {
            axios.delete(`single_boxing/single_boxing/${Input.id}`).then((res) => {
                if (res.data.success === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "Boxing  deleted",
                        type: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    fetchBoxing();
                    setDeleteModal(false);
                    setcompleteStatusKey((prevKey) => prevKey + 1);

                } else {
                    Swal.fire({
                        icon: "error",
                        text: "Server Problem. Please Try Again...",
                        type: "error",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                }
                return;
            });
        } catch (error) {
            throw error;
        }
    };

    const onChangeValue = (e) => {
        setInput({ ...Input, [e.target.name]: e.target.value });
    };

    const columns = [
        { name: "#", selector: (row) => row.sno, sortable: true },
        { name: "Date", selector: (row) => row.date, sortable: true },
        { name: "Staff Name", selector: (row) => row.staffname, sortable: true },
        { name: "Box No", selector: (row) => row.box_no, sortable: true },
        { name: "Color", selector: (row) => row.color, sortable: true },
        { name: "Size with quantity", selector: (row) => row.formatedmarkerwithquantity, sortable: true },
        { name: "Total Piece", selector: (row) => row.totalpiece, sortable: true },
        { name: "Remark", selector: (row) => row.remark, sortable: true },
        {
            name: "Created at",
            selector: (row) => {
                const date = new Date(row.datetime);
                return [`${date.toLocaleDateString("en-GB")}`, `${date.toLocaleTimeString("en-GB", { hour12: false })}`];
            },
            sortable: true,
            cell: (row) => (
                <div>
                    <div>{new Date(row.datetime).toLocaleDateString("en-GB")}</div>
                    <div>{new Date(row.datetime).toLocaleTimeString("en-GB", { hour12: false })}</div>
                </div>
            )
        },
        ...(role === 'Finishing_Staff' || role === 'super_admin' || role === 'FM'
            ? [
                { name: "Option", selector: (row) => row.option }]
            : [])
    ];


    const Data = data?.map((plan, index) => {
        const currentDate = new Date().toLocaleDateString('en-GB');
        const planDate = new Date(plan.datetime).toLocaleDateString('en-GB');

        return {
            sno: index + 1,
            id: plan.boxing_id,
            date: new Date(plan.date).toLocaleDateString('en-GB'),
            formatedmarkerwithquantity: plan.formatted_size_variant,
            markerwithquantity: plan.formatted_size_variant,
            totalpiece: plan.total_piece,
            box_no: plan.box_no,
            remark: plan.remark,
            datetime: plan.datetime,
            staffname: plan.staff_name,
            color:
                <div className="flex items-center space-x-2">
                    <div className="flex items-center justify-center">
                        <img
                            src={`${url}${plan.color_image}`}
                            alt={plan.color}
                            className="w-[25px] h-[25px] object-cover rounded-lg drop-shadow-md"
                        />
                    </div>
                    <span>{plan.color}</span>
                </div>,
            option:
                <div style={{ display: "flex" }}>
                    {(role === 'super_admin' || ((role === 'Finishing_Staff' || role === 'FM') && currentDate === planDate) || ((role === 'FM' && plan.request_status == 'accepted'))) && (
                        <>
                            <FaPen
                                className="text-amber-400 text-xl cursor-pointer"
                                onClick={() => {
                                    // console.log({ id: plan.boxing_log_id });
                                    setInput({
                                        id: plan.boxing_log_id,
                                        date: new Date(plan.date).toISOString().split('T')[0],
                                        markerwithquantity: plan.size_variant_quantity,
                                        totalpiece: plan.total_piece,
                                        box_no: plan.box_no,
                                        remark: plan.remark,
                                    });
                                    setselectedcolor(plan.sub_order_id)
                                    setSelectedBoxNo(plan.box_no)
                                    setselectedMarker(plan.size_variant_quantity);
                                    setEditModal(true);
                                }}
                            />
                            <MdDeleteForever
                                className="ml-2 text-red-500 text-2xl"
                                onClick={() => {
                                    setInput({ id: plan.boxing_log_id });
                                    // console.log({ id: plan.boxing_log_id });
                                    setDeleteModal(true);
                                }}
                            />
                        </>

                    )}

                    {(role === 'FM' && currentDate !== planDate && plan.request_status != 'accepted') && (

                        <TbCircleLetterRFilled
                            className="text-green-500 text-xl "
                            onClick={() => {
                                (plan.request_status == 'request' || plan.request_status == "rejected") && setrequestModal(true); setInput({ id: plan.boxing_log_id ,sub_order_id:plan.sub_order_id });
                            }}
                            style={{
                                color: plan.request_status == 'requested' ? "grey" : "green",
                                cursor: plan.request_status == 'requested' ? "not-allowed" : "pointer",
                            }}
                        />

                    )}
                    {(role === 'FM' || role === 'super_admin') &&
                        <FaRectangleList
                            className="pl-1 text-blue-500 text-2xl"
                            onClick={() => {
                                fetchrequestActivity(plan.boxing_log_id);
                                setrequestActivityModal(true);

                            }}
                        />}
                </div>

        };
    }) || [];

    const fetchavailablequantity = async (sub_order_id) => {
        try {
            const response = await axios.get(`single_boxing/get_available_quantity/${orderid}/${sub_order_id}`);
            const availableQuantityData = response.data.available_quantity;
            if (response.data.success == 3) {
                setselectedMarker(availableQuantityData);
            }
            else {
                setselectedMarker({});
            }
            setavailable_quantityFlag(response.data.success)
        } catch (error) {
            console.error("Error fetching Marker data:", error);
        }
    };


    return (
        <>
            {(role === 'Finishing_Staff' || role === 'super_admin' || role === 'FM') &&
                <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" onClick={() => { setAddBoxing(true); }}>
                    Add Boxing
                </Button>}

            <CSingleBoxingQuantity key={completeStatusKey} orderid={orderid} />
            <div className="overflow-x-auto mt-2">
                <ReusableDataTable columns={columns} data={Data} />
            </div>

            <Modal show={AddBoxing} size="md" onClose={() => { setAddBoxing(false); setselectedMarker({}); }} popup>
                <Modal.Header />
                <Modal.Body>

                    <>
                        <div className="space-y-6">
                            <h3 className="text-xl font-medium text-gray-900 dark:text-white">Add Boxing</h3>
                            <form onSubmit={handleSubmit}>


                                <div className='pt-2'>
                                    <Label htmlFor="orderdate" value="Date" />
                                    <TextInput name="date" type="date" required autoComplete="off" onChange={onChangeValue} value={today} min={today} max={today} />
                                </div>

                                <div className="pt-2 w-full">
                                    <Label htmlFor="boxNo" value="Box No" />
                                    <div className="flex items-center space-x-2">
                                        {/* <TextInput className='w-full' name="box_no" type="text" required value={selectedBoxNo} onChange={(e) => setSelectedBoxNo(e.target.value)} disabled /> */}
                                        <Select
                                            className='w-full'
                                            name="box_no"
                                            value={selectedBoxNo}
                                            onChange={(e) => setSelectedBoxNo(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Box No</option>
                                            {boxNoOptions.length > 0 ? (
                                                boxNoOptions.map((box, index) => (
                                                    <option key={index} value={box}>{box}</option>
                                                ))
                                            ) : (
                                                <option disabled>No boxes available</option>
                                            )}
                                        </Select>
                                        <Button size="xs" className='pt-1 pb-1' color="blue" onClick={createBoxNo} disabled={loading}>
                                            <FaPlus />
                                        </Button>
                                    </div>
                                </div>

                                <div className='pt-2'>
                                    <Label htmlFor="remark" value="Color" />
                                    <CustomSelect
                                        value={selectedColor}
                                        options={Colour}
                                        placeholder="Select a colour"
                                        id={`colour`}
                                        name={`colour`}
                                        includeImage={true}
                                        onChange={(selected) => {
                                            setselectedcolor(selected);

                                            fetchavailablequantity(selected);

                                        }}
                                    />
                                </div>
                                {available_quantityFlag === 1 && (
                                    <Alert color="failure" className="mt-2">
                                        Pressing section has not completed
                                    </Alert>
                                )}

                                {available_quantityFlag === 2 && (
                                    <Alert color="failure" className="mt-2">
                                        Unable to add. The pressing quantity has already been fully transferred to Boxing.
                                    </Alert>
                                )}
                                {available_quantityFlag !== 1 && available_quantityFlag !== 2 && (
                                    <div className='pt-2'>
                                        <Label htmlFor="sizeVariant" value="Size with quantity" />
                                        <CustomSelectwithText
                                            value={selectedMarker}
                                            onChange={(selectedOptions) => setselectedMarker(selectedOptions)}
                                            options={SizeVarientOptions}
                                            id="size-variant-select"
                                            name="sizeVariant"
                                        />
                                    </div>
                                )}
                                <div className='pt-2'>
                                    <Label htmlFor="remark" value="Remark" />
                                    <TextInput name="remark" type="text" autoComplete="off" onChange={onChangeValue} />
                                </div>

                                <div className="pt-3 w-full flex justify-center">
                                    <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" type="submit">Submit</Button>
                                    <Button className="ml-2" color="gray" onClick={() => { setAddBoxing(false); setselectedMarker({}); }}>Cancel</Button>
                                </div>
                            </form>
                        </div>
                    </>

                </Modal.Body>
            </Modal>

            <Modal show={EditModal} size="md" onClose={() => setEditModal(false)} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Edit Boxing</h3>
                        <form onSubmit={handleUpdate}>


                            <div className='pt-2'>
                                <Label htmlFor="orderdate" value="Date" />
                                <TextInput name="date" type="date" value={today} required autoComplete="off" onChange={onChangeValue} min={today} max={today} />
                            </div>

                            <div className="pt-2 w-full">
                                <Label htmlFor="boxNo" value="Box No" />
                                <div className="flex items-center space-x-2">
                                    <Select
                                        className='w-full'
                                        name="box_no"
                                        value={selectedBoxNo}
                                        onChange={(e) => setSelectedBoxNo(e.target.value)}
                                        required
                                    >
                                        <option value="">Select Box No</option>
                                        {boxNoOptions.length > 0 ? (
                                            boxNoOptions.map((box, index) => (
                                                <option key={index} value={box}>{box}</option>
                                            ))
                                        ) : (
                                            <option disabled>No boxes available</option>
                                        )}
                                    </Select>
                                    <Button size="xs" className='pt-1 pb-1' color="blue" onClick={createBoxNo} disabled={loading}>
                                        <FaPlus />
                                    </Button>
                                </div>
                            </div>

                            <div className='pt-2'>
                                <Label htmlFor="remark" value="Color" />
                                <CustomSelect
                                    value={selectedColor}
                                    options={Colour}
                                    placeholder="Select a colour"
                                    id={`colour`}
                                    name={`colour`}
                                    includeImage={true}
                                    onChange={(selected) => {
                                        setselectedcolor(selected);
                                    }}
                                />
                            </div>


                            <div className='pt-2'>
                                <Label htmlFor="sizeVariant" value="Size with quantity" />
                                <CustomSelectwithText
                                    value={selectedMarker}
                                    onChange={(selectedOptions) => setselectedMarker(selectedOptions)}
                                    options={SizeVarientOptions}
                                    id="size-variant-select"
                                    name="sizeVariant"
                                />
                            </div>

                            <div className='pt-2'>
                                <Label htmlFor="remark" value="Remark" />
                                <TextInput name="remark" type="text"  autoComplete="off" value={Input.remark} onChange={onChangeValue} />
                            </div>

                            <div className="pt-3 w-full flex justify-center">
                                <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" type="submit">Submit</Button>
                                <Button className="ml-2" color="gray" onClick={() => { setEditModal(false); setselectedMarker({}); }}>Cancel</Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={DeleteModal} size="md" onClose={() => setDeleteModal(false)} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="text-center">
                        <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400" />
                        <h3 className="mb-5 text-lg font-normal text-gray-500">
                            Are you sure you want to delete this Boxing?
                        </h3>
                        <div className="flex justify-center gap-4">
                            <Button color="failure" onClick={() => handleDelete()}>
                                Yes
                            </Button>
                            <Button color="gray" onClick={() => setDeleteModal(false)}>
                                No
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>



            <Modal
                show={requestModal}
                size="md"
                onClose={() => setrequestModal(false)}
                popup
            >
                <Modal.Header />
                <Modal.Body>
                    <div className="text-center">
                        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                            Are you sure you want to request admin access for editing?
                        </h3>

                    </div>
                    <div className="space-y-6">

                        <form>
                            <div>
                                <div className="pt-2 text-left mb-2 block">
                                    <Label htmlFor="completed-date" value="Reason" />
                                </div>
                                <TextInput
                                    id="reason"
                                    name="reason"
                                    type="text"
                                    required
                                    autoComplete="off"
                                    onChange={onChangeValue}
                                />
                            </div>

                            <div className="pt-3 w-full flex justify-center">
                                <Button className="bg-icon-color text-sidebar-color drop-shadow-md font-bold" type="submit" onClick={(e) => handleRequest(e)}>
                                    Yes
                                </Button>
                                <Button className="ml-2" color="gray" onClick={() => setrequestModal(false)}>
                                    No
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <RequestActivityModal
                show={requestActivityModal}
                onClose={() => setrequestActivityModal(false)}
                requestActivityData={requestActivityData}
            />

        </>
    );
}

export default SingleBoxing;
